// production URI
export const API_URL = "https://ssindustries.5techg.com/api/";

// dev URI
// export const API_URL = "http://localhost:5000/api/";
